export const notAllowedWebviewRefreshVersionCodes = [1103, 1106];

export const ORDERID_MISMATCH_ALERT_DATA = {
    title: "Something went wrong! Please try again",
    ctaText: "Go to Cart",
    icon: "PaymentLogos/paymentIcons/error",
};
